import { Helmet } from 'react-helmet-async';

/**
 * Mark a route as non-indexable for search engines.
 * Used on authed app routes, auth pages, admin, and any URL we don't want crawled
 * since the product has moved to mobile-only.
 */
export function NoIndex() {
  return (
    <Helmet>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
  );
}
